import { render, staticRenderFns } from "./Labeling.vue?vue&type=template&id=2dc1516e"
import script from "./Labeling.vue?vue&type=script&lang=js"
export * from "./Labeling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports